export const profile = {
    text1: "Meine Kontoinformationen",
    text2: "Persönliche Daten",
    text3: "Name",
    text4: "Ausweisnummer",
    text5: "Telefon",
    text6: "Land",
    text7: "E-Mail-Adresse",
    text8: "Daten aktualisieren",
    text9: "Zugangsdaten",
    text10: "Passwort",
    text11: "Passwort bestätigen",
    text12: "Passwort aktualisieren",

    // Corrections
    p1: "Kontoeinstellungen",
    p2: "Profildaten",
    p3: "Anmeldung und Sicherheit",
    p4: "Rechnungsdaten",
    p5: "Primäre E-Mail-Adresse",
    p6: "Hier erhalten Sie alle Mitteilungen von WACheckin",
    p7: "Kontoinformationen",
    p8: "Verwalten Sie Ihre Kontodaten.",
    p9: "Name",
    p10: "Vollständigen Namen eingeben",
    p11: "Ausweisnummer",
    p12: "Ausweisnummer eingeben",
    p13: "Telefon",
    p14: "Telefonnummer eingeben",
    p15: "Anmeldung und Sicherheit",
    p16: "Aktualisieren Sie Ihr Passwort und schützen Sie Ihr Konto.",
    p17: "Kontopasswort",
    p18: "Zuletzt aktualisiert:",
    p19: "Passwort ändern",
    p20: "Rechnungsdaten",
    p21: "Verwalten Sie Ihre Kontodaten.",
    p22: "Firmenname",
    p23: "Firmennamen eingeben",
    p24: "Steuernummer",
    p25: "Steuernummer eingeben",
    p26: "Rechnungsadresse",
    p27: "Rechnungsadresse eingeben",
    p28: "Land",
    p29: "Bundesland",
    p30:'Postleitzahl',
    p31:`Keine Rechnungsdaten`,
    p32:`Die Rechnungsdaten werden beim Abschluss eines Abonnements automatisch übernommen.`,
};
